import React from "react";
import AdminBreadCrumb from "components/AdminBreadCrumb";
import FacturasList from "../components/FacturasList";

const FacturasPageNew = () => {
  const breadCrumbs = [
    { text: "BILLING", url: "/admin/facturas" },
    { text: "FACTURAS", url: "/admin/facturas" }
  ];

  return (
    <div className="facturas-page admin">
      <div className="common-header">
        <AdminBreadCrumb breadCrumbs={breadCrumbs} />
      </div>

      <div className="content-wrapper">
        <FacturasList />
      </div>
    </div>
  );
};

export default FacturasPageNew;
